module.exports = __webpack_public_path__ + "08678a921245f167aff04d08acfdfb89.jpg";